<template>
  <div class="hello">
    <div class="row">
      <div class="he-wos">
        <div class="container">
          <div class="col-xs-12 col-md-12">
            <div class="fade-in full-width">
              <div class="demo-carousels">
                <Carousel
                  v-model="value"
                  :autoplay="setting.autoplay"
                  :autoplay-speed="setting.autoplaySpeed"
                  :dots="setting.dots"
                  :radius-dot="setting.radiusDot"
                  :trigger="setting.trigger"
                  :arrow="setting.arrow"
                >
                  <CarouselItem v-for="(item, index) in image" :key="index">
                    <div class="demo-carousel">
                      <img :src="item" alt="" />
                    </div>
                  </CarouselItem>
                </Carousel>
              </div>
            </div>
          </div>

          <!-- <div class="fade-in full-width">
            <div class="dynamec">
              <div class="dy-title-lift">
                <h2>集运流程</h2>
                <p style="font-size: 16px">
                  只需包裹寄到仓库,剩余步骤仓库处理,高效便捷
                </p>
              </div>
              <div class="dy-tile-bom">
                <div class="row bom-top">
                  <div class="col-xs-6 col-md-3">
                    <div class="prote-pick">
                      <img src="@/staats/STEP-1.jpg" alt="" />
                      <i class="el-icon-arrow-right"></i>
                    </div>
                    <div class="rist">
                      <h4>STEP 1</h4>
                      <p style="font-size: 16px">货物寄送至仓库</p>
                    </div>
                  </div>
                  <div class="col-xs-6 col-md-3">
                    <div class="prote-pick">
                      <img src="@/staats/STEP-2.jpg" alt="" />
                      <i class="el-icon-arrow-right"></i>
                    </div>
                    <div class="rist">
                      <h4>STEP 2</h4>
                      <p style="font-size: 16px">仓库合包邮寄</p>
                    </div>
                  </div>
                  <div class="col-xs-6 col-md-3">
                    <div class="prote-pick">
                      <img src="@/staats/STEP-3.jpg" alt="" />
                      <i class="el-icon-arrow-right"></i>
                    </div>
                    <div class="rist">
                      <h4>STEP 3</h4>
                      <p style="font-size: 16px">出库寄往国外</p>
                    </div>
                  </div>
                  <div class="col-xs-6 col-md-3">
                    <div class="prote-pick">
                      <img src="@/staats/STEP-4.jpg" alt="" />
                    </div>
                    <div class="rist">
                      <h4>STEP 4</h4>
                      <p style="font-size: 16px">到货签收</p>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-xs-12 col-md-12 coldes">
                  <div class="el-top-img">
                    <img src="@/staats/banner.jpg" alt="" />
                  </div>
                </div>
              </div>
            </div>
          </div> -->

          <div class="fade-in full-width" align="center">
            <div class="he-wods-boom">
              <div class="he-wpp">
                <p style="font-size: 64px">深圳猩火商贸</p>
                <br />
                <p style="font-size: 30px">
                  猩火商贸创总部位于中国深圳，分别在广州、湖南、洛杉矶设有分公司，目前涉有两大业务板块，分别是国际物流以及跨境B2C电商平台。</p><br />
                  <p style="font-size: 25px">公司自成立以来，一直深耕国际物流服务，特别专注于美国专线物流，拥有30<br />
                  余种跨境物流解决方案，包括美国专线全程服务和美国本土
                  usps/ups/fedex 尾程账号服务。<br />
                  是著名三大快递公司（UPS/FEDEX/DHL）、美国邮政 USPS<br />
                  的战略合作伙伴。我司拥有专业团队，通过自主研发的国际物流系统，无缝对接<br />
                  USPS/UPS/FEDEX/DHL 系统和各大物流资源渠道，支持 API<br />
                  对接自主打单，实时掌握最新轨迹信息，为全球 6000<br />
                  多家跨境电商卖家、美国海外仓及物流货代公司提供全美全境的尾程派送服务。
                </p>
                <p style="font-size: 8px">
                  <br /><br /><br /><br /><br /><br /><br /><br /><br />
                  <br /><br /><br /><br /><br /><br /><br /><br /><br />
                </p>
              </div>
              <div class="row">
                <div class="he-boots">
                  <div
                    class="col-xs-6 col-md-3 col-pers"
                    v-for="(item, index) in tabers"
                    :key="index"
                  >
                    <img :src="item.imgage" alt="" />
                    <h4>{{ item.prike }}</h4>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- <div class="fade-in full-width">
            <div class="he-news">
              <div class="he-list">
                <h2>动态资讯</h2>
                <p>为你提供最新的行业资讯，动态消息</p>
              </div>
              <div class="colot"></div>
              <div class="he-totpe-post">
                <div class="he-btoosm">
                  <h3>最新消息</h3>
                  <p>采集插件</p>
                  <p>各国征税点</p>
                </div>
                <div class="he-btoosm">
                  <h3>集运服务</h3>
                  <p>集运承运契约条款</p>
                  <p>海关总罢:邮寄进境物品超50元须纳税</p>
                  <p>2016年全国快递业务收入4005亿元</p>
                </div>
                <div class="he-btoosm">
                  <h3>常见问题</h3>
                  <p>渠道查询备注</p>
                  <p>哪些物品国家禁止进境</p>
                  <p>UPS的红单和蓝单分别是什么意思呢?</p>
                  <p>各国海关对货物进口的限制要求</p>
                  <p>保障仓储货物安全的技巧</p>
                </div>
              </div>
            </div>
          </div> -->

          <!-- <div class="fade-in full-width">
            <div class="he-news">
              <div class="he-list">
                <h2>会员服务</h2>
              </div>
              <div class="colot"></div>
              <div class="he-totpe-post">
                <div class="he-btoosm">
                  <h3>集运流程</h3>
                  <p>集运流程说明</p>
                  <p>会员下单教程（PC端）</p>
                  <p>会员下单教程（手机微信端）</p>
                </div>
                <div class="he-btoosm">
                  <h3>我要集运</h3>
                  <p>账号注册登录</p>
                  <p>添加仓库地址</p>
                  <p>确认收货</p>
                </div>
                <div class="he-btoosm">
                  <h3>查询服务</h3>
                  <p>物流查询</p>
                  <p>包裹认领</p>
                  <p>确认收货</p>
                  <p>申请邮寄</p>
                  <p>订单付款</p>
                </div>
              </div>
            </div>
          </div> -->
        </div>

        <div class="cl-tob-btoome">
          <div class="cl-tos-btns">
            <div class="row">
              <div class="col-xs-12 col-md-12 rowsplay">
                <p>合作邮箱：szxhsm2022@163.com</p>
                <p>
                  详细地址:深圳市龙华区观湖街道樟溪社区下围工业区一路1号C栋103
                </p>
                <!-- <span><img src="@/staats/kefu.jpg" alt=""> </span> -->
              </div>
            </div>
          </div>
          <div class="tile-byom">
            <p>
              © Copyright 2022 深圳猩火商贸 Rights Reserved
              <a href="https://beian.miit.gov.cn/" target="_blank"
                >粤ICP备xxx号</a
              >
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    msg: String,
  },
  data() {
    return {
      value: 0,
      setting: {
        autoplay: true,
        autoplaySpeed: 10000,
        dots: "inside",
        radiusDot: false,
        trigger: "click",
        arrow: "hover",
        fadeInElements: [],
      },
      value1: 0,
      image: [
        require("@/staats/two.jpg"),
        // require("@/staats/banner2.jpg"),
        // require("@/staats/banner1.jpg"),
      ],
      tabers: [
        // { imgage: require("@/staats/fuw1.jpg"), prike: "0.5kg起送不拼邮" },
        // { imgage: require("@/staats/fuw2.jpg"), prike: "时效3-7个工作日" },
        // { imgage: require("@/staats/fuw3.jpg"), prike: "满300减50" },
        // { imgage: require("@/staats/fuw4.jpg"), prike: "丢件赔付" },
        // { imgage: require("@/staats/fwu5.jpg"), prike: "自营专线" },
        // { imgage: require("@/staats/fuw8.jpg"), prike: "超时包赔" },
        // { imgage: require("@/staats/fwu7.jpg"), prike: "易碎保护" },
        // { imgage: require("@/staats/fuw6.jpg"), prike: "双清包税" },
      ],
      bg: {
        backgroundImage: "url(" + require("@/staats/banner3.png") + ")",
        backgroundRepeat: "no-repeat",
        backgroundSize: "100% 100%",
      },
    };
  },
  mounted() {},
  methods: {},
};
</script>


<style scoped lang="scss">
.rist {
  h4 {
    padding: 10px;
  }
  p {
    padding: 10px;
  }
}
.container {
  padding: 0;
  width: 100%;
  min-width: 100%;
  margin: 0 auto;
}

.el-icon-arrow-right {
  font-size: 60px;
  margin-right: -10px;
}
.full-width {
  width: 100%;
}

.half-width {
  width: 47.5%;
}

.he-wos {
  width: 100%;
  // height: 900px;
  padding: 0;
  position: absolute;
  top: 85px;
  left: 0;
}
.demo-carousels {
  width: 100%;
  img {
    width: 100%;
  }
}
.he-wods-boom {
  width: 100%;
  background: #f5f5f5;
  .he-wpp {
    margin-top: -843px;
    position: relative;
  }
  h2 {
    text-align: center;
    font-size: 30px;
  }
  p {
    text-align: center;
    padding: 10px;
    color: #2400a8;
  }
  .he-boots {
    width: 100%;
    display: flex;
    flex-wrap: wrap;

    .col-pers {
      padding: 10px;
      text-align: center;
      margin: 0 auto;
      img {
        height: 100px;
        width: 100px;
      }
      h4 {
        padding: 50px;
      }
    }
    .he-noewst {
      height: 400px;
      // border: 1px solid #cccccc;
      .he-movest {
        height: 300px;
        // border: 1px solid #cccccc;
        margin: 0 auto;
      }
      img {
        width: 100%;
        max-width: 100%;
        height: 100%;
        max-height: 300px;
      }
      .he-sizes {
        padding: 10px;
        h3 {
          text-align: center;
        }
      }
    }
  }
}
.coldes {
  padding: 0;
}
.el-top-img {
  width: 100%;

  img {
    width: 100%;
  }
}
.dynamec {
  width: 100%;
  .dy-title-lift {
    // width: 50%;
    margin: 20px auto;
    h2 {
      font-size: 30px;
      text-align: center;
      padding: 10px;
    }
    p {
      text-align: center;
      padding: 10px;
    }
  }
  .dy-tile-bom {
    width: 100%;
    .bom-top {
      width: 100%;
      padding: 30px;
      display: flex;
      justify-content: space-between;
      text-align: center;
      .prote-pick {
        position: relative;
        img {
          width: 70%;
        }
        i {
          position: absolute;
          top: 60px;
          right: -22px;
        }
      }
    }
  }
}
.he-news {
  width: 100%;
  padding: 10px;
  .colot {
    width: 80%;
    margin: 0 auto;
    border: 1px solid rgba(0, 195, 255);
    background: rgba(0, 195, 255);
  }
  .he-list {
    width: 50%;
    margin: 20px auto;
    h2 {
      font-size: 30px;
      text-align: center;
    }
    p {
      text-align: center;
      padding: 10px;
      font-size: 14px;
    }
  }
  .he-totpe-post {
    display: flex;
    margin: 0 auto;
    padding: 10px;
    width: 80%;
    .he-btoosm {
      width: 40%;
      text-align: left;
      p {
        padding: 10px;
        font-size: 14px;
      }
    }
  }
}
.cl-tob-btoome {
  width: 100%;
  background: #000000;
  .cl-tos-btns {
    .rowsplay {
      display: flex;
      justify-content: center;
      p {
        color: white;
      }
    }
  }
}

.row {
  margin: 0;
}
.tile-byom {
  width: 100%;
  p {
    color: rgba(255, 255, 255);
    text-align: center;
    font-size: 12px;
  }
}
</style>
